import * as React from 'react';

import * as styles from './DropdownBackdrop.css';

export const DropdownBackdrop: React.FC = () => <div className={styles['backdrop']} />;
